import script from "./SubNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SubNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SubNavigation.vue?vue&type=style&index=0&id=04222f5e&lang=scss"

const __exports__ = script;

export default __exports__